export function transitionIn(selector) {
    document.querySelector(selector).style.width = '100%';
}

export function transitionOut(selector) {
    document.querySelector(selector).style.width = '0';
}
